import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '@environments/environment';
import {Result} from '@domain/common/http/result';
import {Fournisseur} from '@domain/facture/fournisseur';
import {first} from "rxjs/operators";
import {Injectable} from "@angular/core";

/**
 * Service de gestion des fournisseurs
 *
 * @author Yannick Gauthier
 * @date 15/07/2025
 */
@Injectable({
    providedIn: 'root'
})
export class FournisseursService {

    /**
     * Constructeur
     *
     * @param http Client HTTP
     */
    constructor(private http: HttpClient) {
    }

    /**
     * Récupère un fournisseur par son id
     *
     * @param idFournisseur Id du fournisseur
     */
    getFournisseurById(idFournisseur: number): Observable<Result> {
        let params = new HttpParams().set('idFournisseur', idFournisseur.toString());
        return this.http.post<Result>(`${environment.baseUrl}/controller/Contrat/loadFournisseur`, null, {params: params}).pipe(first());
    }

    /**
     * Sauvegarde un fournisseur
     *
     * @param fournisseur Fournisseur à sauvegarder
     */
    saveFournisseur(fournisseur: Fournisseur): Observable<Result> {
        return this.http.post<Result>(`${environment.baseUrl}/controller/Contrat/saveFournisseur`, fournisseur);
    }

    /**
     * Supprime un fournisseur
     *
     * @param fournisseur fournisseur à supprimer
     */
    deleteFournisseur(fournisseur: Fournisseur): Observable<Result> {
        return this.http.post<Result>(`${environment.baseUrl}/controller/Contrat/deleteFournisseur`, fournisseur);
    }
}
